import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '@ap/http';

import * as FullStory from '@fullstory/browser';

import { BrandingService } from '@library/common/branding';
import {
   BrowserCheckService,
   BreakpointService,
   EnvironmentService,
   GoogleAnalyticsService,
   MaintenanceService,
   PortalService,
} from '@library/core/services';

@Component({
   selector: 'app-root',
   template: `<router-outlet></router-outlet>`,
})
export class AppComponent {
   constructor(
      public router: Router,
      public branding: BrandingService,
      private e: EnvironmentService,
      private gtag: GoogleAnalyticsService,
      private check: BrowserCheckService,
      private breakpoints: BreakpointService,
      private maintenance: MaintenanceService,
      private portalService: PortalService,
   ) {
      this.portalService.current = 'agent';
      this.e.environment = environment;
      this.gtag.load( environment?.gtagId );
      this.breakpoints.tap();
      this.check.check();
      this.maintenance.check();
      FullStory.init({ orgId: 'o-1MB0F2-na1', devMode: !environment.production });
   }
}
